import { Status } from './getChannelStatus'

interface Channel {
  id: string
  service: string
  type: string
}

interface ShouldShowRefreshButtonOptions {
  channel: Channel
  status?: Status
}

/**
 * Determines if a refresh button should be shown for a given channel.
 * Returns true to show the button (which can then be disabled based on permissions).
 * Returns false to completely hide the button for special cases.
 */
export const shouldShowRefreshButton = ({
  channel,
  status,
}: ShouldShowRefreshButtonOptions): boolean => {
  // Don't show for locked channels
  if (status === Status.Locked) {
    return false
  }

  // Don't show for start pages, which don't need refreshing
  const isChannelStartPage = channel.service === 'startPage'
  if (isChannelStartPage) {
    return false
  }

  // Don't show for Facebook groups - they have their own "Edit Group" flow
  const isFacebookGroup =
    channel.service === 'facebook' && channel.type === 'group'
  if (isFacebookGroup) {
    return false
  }

  // Don't show for Instagram personal profiles - they have their own "Edit Profile" flow
  const isInstagramPersonalProfile =
    channel.service === 'instagram' && channel.type === 'profile'
  if (isInstagramPersonalProfile) {
    return false
  }

  // Show button for all other cases
  return true
}
